/* eslint-disable max-len */
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const OpenHexaSvg = (props: SvgIconProps & { disabled: boolean }) => {
    const finalProps = {
        ...props,
        viewBox: '0 0 44 48',
    };
    return (
        <SvgIcon {...finalProps}>
            <g clipPath="url(#clip0_3045_579)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M42.3892 14.4791C42.3892 12.876 41.2588 10.9004 39.8792 10.0886L23.7585 0.608863C22.3763 -0.202954 20.1182 -0.202954 18.736 0.608863L2.61783 10.0886C1.23826 10.903 0.10788 12.876 0.10788 14.4791V33.5209C0.10788 35.124 1.23826 37.0996 2.61783 37.9114L18.736 47.3911C20.1182 48.203 22.3763 48.203 23.7585 47.3911L39.8767 37.9114C41.2588 37.0996 42.3866 35.124 42.3866 33.5209V14.4791H42.3892Z"
                    fill={props.disabled ? 'rgba(0, 0, 0, 0.12)' : '#FF3E96'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M42.3892 14.4791C42.3892 12.876 41.2588 10.9004 39.8792 10.0886L23.7585 0.608863C22.3763 -0.202954 20.1182 -0.202954 18.736 0.608863L2.61783 10.0886C1.23826 10.903 0.10788 12.876 0.10788 14.4791V33.5209C0.10788 35.124 1.23826 37.0996 2.61783 37.9114L18.736 47.3911C20.1182 48.203 22.3763 48.203 23.7585 47.3911L39.8767 37.9114C41.2588 37.0996 42.3866 35.124 42.3866 33.5209V14.4791H42.3892Z"
                    fill="url(#paint0_linear_3045_579)"
                />
                <path
                    d="M19.8304 40.1053C19.4271 40.1053 19.016 40 18.6461 39.7765L7.59921 33.1663C6.90043 32.7502 6.47397 31.9949 6.47397 31.183V16.5626C6.47397 15.7277 6.92355 14.9595 7.65059 14.5485L15.2524 10.2608C15.9692 9.85742 16.8452 9.86256 17.5543 10.2787C18.2633 10.6924 18.7 11.4528 18.7 12.2749V19.6712L27.2704 24.6834C27.9794 25.097 28.4162 25.8574 28.4162 26.6795V31.7714L31.3937 30.0912V18.1297L21.4772 12.1927C20.3828 11.5376 20.0257 10.1169 20.6808 9.02248C21.3359 7.92807 22.7566 7.57097 23.851 8.22608L34.8953 14.8362C35.5941 15.2524 36.0205 16.0077 36.0205 16.8195V31.4399C36.0205 32.2749 35.571 33.043 34.8439 33.4541L27.2421 37.7418C26.5254 38.1452 25.6493 38.14 24.9403 37.7238C24.2312 37.3102 23.7945 36.5498 23.7945 35.7277V28.0026L15.2241 22.9929C14.5151 22.5793 14.0783 21.8189 14.0783 20.9968V16.2312L11.1008 17.9114V29.8703L21.0225 35.8073C22.1169 36.4624 22.474 37.8831 21.8189 38.9775C21.3847 39.7046 20.6165 40.1053 19.8304 40.1053Z"
                    fill="white"
                />
            </g>
        </SvgIcon>
    );
};
